User = function (data) {
    var self = this;

    var props = [
        {name: 'name'},
        {name: 'avatar'},
        {name: 'username'},
        {name: 'email'},
        {name: 'karma'},
        {name: 'level'},
        {name: 'isAdmin', data_type: 'boolean', default: false},
        {name: 'streak', data_type: 'integer', default: null},
        {name: 'onfire', data_type: 'integer', default: null},
        {name: 'active_trophy', data_type: 'object', default: null},
        {name: 'isModerator', data_type: 'boolean', default: false},
        {name: 'birth_date'},
        {name: 'impersonating', data_type: 'boolean', default: false},
        {name: 'onboarded', data_type: 'boolean', default: false},
        {name: 'password_changed_at', data_type: 'string', default: null},
        {name: 'origin', data_type: 'string', default: 'system'},
    ];

    self.activeDataRelations = [
        //{type: 'hasMany', storeTarget: 'likes', key: 'user_id', storage: 'likes'},
        {type: 'hasMany', storeTarget: 'comments', key: 'user_id', storage: 'comments'},
        {type: 'hasMany', storeTarget: 'topics', key: 'user_id', storage: 'topics'}
    ];

    ActiveData.call(self, data); //javascript 'classes' workaround
    self.activeDataInit(self, data, props); //setup active data
};
